import { useModel } from "@umijs/max";
import { Space } from "antd";
import React from "react";
import AvatarDropdown from "./AvatarDropdown";
import EnvDropdown from "./EnvDropdown";
import styles from "./index.less";
import HeaderNotice from "@/components/HeaderNotice";
import HeaderFeedback from "@/components/HeaderFeedback";
import HeaderDownload from "../HeaderDownload";
// import {
//   QuestionCircleOutlined,
//   SearchOutlined,
//   SettingOutlined,
//   SoundOutlined,
// } from '@ant-design/icons';
// import HeaderSearch from '../HeaderSearch';

export type SiderTheme = "light" | "dark";

const GlobalHeaderRight: React.FC = () => {
  const { initialState } = useModel("@@initialState");

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === "realDark" && layout === "top") || layout === "mix") {
    className = `${styles.right}  ${styles.dark}`;
  }
  return (
    <Space className={className} size="middle">
      {/* <HeaderSearch
        className={`${styles.action} ${styles.search}`}
        placeholder="站内搜索"
        defaultValue=""
        options={[
          {
            label: (
              <Link
                to={{
                  pathname: `/goods/detail`,
                }}
                target="_blank"
              >
                发布商品
              </Link>
            ),
            value: '发布商品',
          },
          { label: <a href="/goods/list">商品列表</a>, value: '商品列表' },
        ]}
        // onSearch={value => {
        //   console.log('input', value);
        // }}
      /> */}
      {/* <span
        className={styles.action}
        onClick={() => {
          window.open('https://pro.ant.design/docs/getting-started');
        }}
      >
        <QuestionCircleOutlined />
      </span> */}
      {/* <Input
        prefix={<SearchOutlined />}
        placeholder="搜信息"
        className="w-[247px] border-r-[6px]"
      />
      <Divider type="vertical" />
      <div className={styles.action}>
        <SoundOutlined />
      </div>
      <div className={styles.action}>
        <SettingOutlined />
      </div>
      <div className={styles.action}>
        <QuestionCircleOutlined />
      </div> */}
      <EnvDropdown />
      <HeaderDownload />
      <HeaderNotice />
      <HeaderFeedback />
      <AvatarDropdown menu={false} />
      {/*<SelectLang className={styles.action} />*/}
    </Space>
  );
};
export default GlobalHeaderRight;
